import { render, staticRenderFns } from "./LoadSpin2.vue?vue&type=template&id=3c5f04d4&scoped=true&"
var script = {}
import style0 from "./LoadSpin2.vue?vue&type=style&index=0&id=3c5f04d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5f04d4",
  null
  
)

export default component.exports